import React, { Component } from 'react'

class MoreText extends Component {
  constructor(props) {
    super(props)

    const limitTextLength = this.props.limitTextLength
    const moreText = this.props.children.slice(limitTextLength)

    this.state = {
      showMore: moreText === '' ? true : false,
      text: this.props.children.slice(0, limitTextLength),
      moreText,
    }
  }

  showMore() {
    this.setState(state => ({
      ...state,
      showMore: true
    }), () => {
      window.dispatchEvent(new Event('resize'))
      if (this.props.onShowMore) {
        this.props.onShowMore()
      }
    })
  }

  render() {
    return (
      <div className={`${this.props.className}`}>
        <span
          dangerouslySetInnerHTML={{ __html: this.state.text}}
        ></span>
        {
          this.state.showMore
            ? (
              <span
                dangerouslySetInnerHTML={{ __html: this.state.moreText}}
              ></span>
            ) : (
              <span>
                ...<button onClick={() => this.showMore()} className="text-blue-500 underline">more</button>
              </span>
            )
        }
      </div>
    )
  }
}

MoreText.defaultProps = {
  className: '',
  limitTextLength: 450,
}

export default MoreText
